import { serializable, alias, primitive, list, object } from 'serializr';


export class CategoriesList{
    @serializable
    label?: string;

    @serializable
    status?: boolean;
}